import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export const useTotpCodeDialogValidationSchema = () => {
  const { t } = useTranslation();

  const schema = z.object({
    totpCode: z
      .string()
      .trim()
      .regex(/^\d{6}$/, t('common:invalidCode')),
  });

  return schema;
};

export type FormValues = z.infer<
  ReturnType<typeof useTotpCodeDialogValidationSchema>
>;
